import type { TextareaHTMLAttributes } from 'react'
import styles from './Textarea.module.css'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean
  /**
   * Мягкий предел длины: показывает счётчик, но не обрезает ввод.
   *
   * Именно мягкий. Жёсткий maxLength молча съедает вставленный из
   * буфера текст, и человек узнаёт об этом, когда агент на звонке
   * обрывает фразу на середине.
   */
  limit?: number
}

export function Textarea({ invalid, limit, className, value, ...rest }: TextareaProps) {
  const classes = [styles.textarea, invalid && styles.invalid, className]
    .filter(Boolean)
    .join(' ')

  const length = typeof value === 'string' ? value.length : 0

  return (
    <>
      <textarea className={classes} value={value} {...rest} />
      {limit && (
        <span className={`${styles.counter} ${counterState(length, limit)}`}>
          {length} / {limit}
        </span>
      )}
    </>
  )
}

function counterState(length: number, limit: number): string {
  if (length > limit) return styles.counterOver ?? ''
  if (length > limit * 0.9) return styles.counterNear ?? ''
  return ''
}
